import { AvailableLanguage } from '@/models/AvailableLanguage';
import Category from '@/models/Category';
import { Tags } from '@/store/tag/types';
import * as Yup from 'yup';

export interface LessonForm {
    name: string;
    description?: string;
    mainImage?: string;
    author: string;
    prerequisites: boolean;
    mandatory: boolean;
    categories: Category[];
    tags: Tags[];
    path?: string;
    workload?: number;
    subtitle?: string;
    editorState?: string;
    availableSubtitles?: AvailableLanguage[];
}

export interface TypeDynamic {
    dynamicAttributes: DynamicAttribute;
}

export interface DynamicAttribute {
    method: string;
    type: string;
}

export const lessonSchema: Yup.ObjectSchema<LessonForm> = Yup.object().shape<LessonForm>({
    name: Yup.string().required(),
    author: Yup.string().required(),
    prerequisites: Yup.boolean().required(),
    mandatory: Yup.boolean().required(),
    categories: Yup.array<Category>().min(1),
    tags: Yup.array<Tags>().min(1),
    path: Yup.string().when(['$pathRequired'], (pathRequired: boolean) => (pathRequired ? Yup.string().required() : Yup.string().notRequired())),
    editorState: Yup.string().when(['$editorStateRequired'], (editorStateRequired: boolean) =>
        editorStateRequired ? Yup.string().required() : Yup.string().notRequired(),
    ),
    workload: Yup.number().when('$workloadRequired', (workloadRequired: boolean) =>
        workloadRequired
            ? Yup.number()
                  .required()
                  .min(1)
            : Yup.number().notRequired(),
    ),
});

export const formInitialState = {
    '@class': '.LessonContentTO',
    mainImage: undefined,
    description: '',
    name: '',
    author: '',
    prerequisites: false,
    mandatory: true,
    categories: [],
    tags: [],
    path: '',
    workload: 0,
    subtitle: '',
    dynamicAttributes: { method: '', type: '' },
    availableSubtitles: [] as AvailableLanguage[],
};

export const formErrors = {
    dynamicAttributesError: false,
    mainImageError: false,
    nameError: false,
    authorError: false,
    descriptionError: false,
    categoriesError: false,
    tagsError: false,
    workload: false,
    path: false,
    subtitle: false,
};
